// React
import { useCallback } from 'react'

// Models
import { useStores } from 'models'

// Interfaces
import { IDocumentDetailGetDropdownAttrs } from 'interfaces/back-office/master/document-detail/document-detail-view.interface'

const useMasterDocumentDetail = () => {
  // Hook
  const {
    masterDocumentDetail: {
      masterDocumentDetail_isLoading,
      masterDocumentDetail_dropdown,
      masterDocumentDetail_CLEAR_DOCUMENT_DETAIL_DROPDOWN,
      masterDocumentDetail_fetchDocumentDetailDropdown: masterDocumentDetailFetchDropdown,
    },
  } = useStores()

  /**
   * @description Fetch dropdown
   *
   * @param {IDocumentDetailGetDropdownAttrs} payload
   *
   * @return {Promise<void>} Promise<void>
   */
  const masterDocumentDetail_fetchDocumentDetailDropdown = useCallback(
    (payload: IDocumentDetailGetDropdownAttrs): Promise<void> => {
      return new Promise((resolve, reject) => {
        masterDocumentDetailFetchDropdown({
          requestConfig: payload.requestConfig,
          onSuccess: resolve,
          onError: reject,
        })
      })
    },
    // eslint-disable-next-line
    [],
  )

  return {
    masterDocumentDetail_isLoading,
    masterDocumentDetail_dropdown,
    masterDocumentDetail_CLEAR_DOCUMENT_DETAIL_DROPDOWN,
    masterDocumentDetail_fetchDocumentDetailDropdown,
  }
}

export { useMasterDocumentDetail }
